import styled from 'styled-components'
import usePageVisibilityHook from 'src/hooks/usePageVisibility.hook'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useState } from 'react'
import useMatchHook from 'src/hooks/useMatch.hook'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'

const BackgroundToForegroundDimScreen = () => {
  const { currentMedia } = useMediaQueryHook()
  const [pageActiveToggle, setPageActiveToggle] = useState(false)
  const { m_login } = useMatchHook()
  const { type } = useAppSelector((state: RootState) => state.modal)
  usePageVisibilityHook((isForeground: boolean) => {
    if (!m_login && currentMedia !== 'pc' && type !== 'backupData' && isForeground) {
      setPageActiveToggle(true)
    }
  })
  return (
    <DimScreenWrap
      pageactivetoggle={`${pageActiveToggle}`}
      onClick={() => window.location.reload()}
    />
  )
}
export default BackgroundToForegroundDimScreen

const DimScreenWrap = styled.div<{ pageactivetoggle: string }>`
  display: ${(props) => (props.pageactivetoggle === 'true' ? 'block' : 'none')};
  z-index: 9999;
  width: 100%;
  overflow: hidden;
  min-height: calc(var(--vh, 1vh) * 100);
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  opacity: 0.3;
`
